import { Link } from "react-router-dom";
import { ArrowRight, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const COLS = [
  { head: "Explore", links: ["About HARC", "Approach", "Impact", "Careers"] },
  { head: "Connect", links: ["Start a Conversation", "Newsletter Sign-Up", "Events"] },
  { head: "Resources", links: ["Insights & Resources", "Reports", "Podcasts", "News"] },
];

const LINK_MAP = {
  "About HARC": "/about",
  Approach: "/approach",
  Careers: "/careers",
  "Start a Conversation": "/start-a-conversation",
  "Insights & Resources": "/insights",
  Impact: "/impact",
};

const SOCIAL = [
  { icon: Facebook, label: "HARC on Facebook", href: "https://www.facebook.com/HARCResearch.org" },
  { icon: Twitter, label: "HARC on X / Twitter", href: "https://twitter.com/HARCresearch" },
  { icon: Instagram, label: "HARC on Instagram", href: "https://www.instagram.com/harcresearch/" },
  {
    icon: Linkedin,
    label: "HARC on LinkedIn",
    href: "https://www.linkedin.com/company/houston-advanced-research-center/",
  },
];

export const MockFooter = () => (
  <footer className="bg-[#022A42] text-[#FFFFFF]" data-testid="mockup-footer">
    <div className="brand-stripe" aria-hidden="true" />
    <div className="mx-auto max-w-7xl px-6 py-20">
      <div className="flex flex-wrap items-center justify-between gap-8 border-b border-[#FFFFFF]/15 pb-16">
        <h2 className="harc-heading max-w-xl text-3xl font-light leading-tight md:text-4xl">
          Have a Complex Challenge? Let's find the right solution together.
        </h2>
        <Link
          to="/start-a-conversation"
          data-testid="footer-cta"
          className="inline-flex items-center gap-3 rounded-full bg-[#FFA100] px-7 py-3.5 text-xs font-bold uppercase tracking-[0.12em] text-[#022A42] transition-colors hover:bg-[#D98A00]"
        >
          Let's Solve Something Together <ArrowRight size={15} aria-hidden="true" />
        </Link>
      </div>

      <div className="grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="harc-heading text-2xl font-semibold">HARC</p>
          <p className="mt-4 text-sm leading-relaxed text-[#FFFFFF]/70">
            Where Science Creates Solutions, turning insight into resilient infrastructure,
            sustainable growth, and a healthier environment.
          </p>
          <div className="mt-6 flex gap-4">
            {SOCIAL.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="text-[#FFFFFF]/70 transition-colors hover:text-[#FFA100]"
              >
                <s.icon size={19} />
              </a>
            ))}
          </div>
        </div>
        {COLS.map((c) => (
          <nav key={c.head} className="md:col-span-2" aria-label={c.head}>
            <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.18em] text-[#FFFFFF]/50">
              {c.head}
            </p>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  {LINK_MAP[l] ? (
                    <Link
                      to={LINK_MAP[l]}
                      className="text-sm text-[#FFFFFF]/80 transition-colors hover:text-[#FFA100]"
                    >
                      {l}
                    </Link>
                  ) : (
                    <a
                      href="#top"
                      className="text-sm text-[#FFFFFF]/80 transition-colors hover:text-[#FFA100]"
                    >
                      {l}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 border-t border-[#FFFFFF]/15 pt-8 text-xs text-[#FFFFFF]/60">
        <p>© 2026 HARC · [HARC CONTENT REQUIRED: address]</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="transition-colors hover:text-[#FFFFFF]">
            Privacy Policy
          </Link>
          <Link to="/terms" className="transition-colors hover:text-[#FFFFFF]">
            Terms of Use
          </Link>
          <Link to="/accessibility" className="transition-colors hover:text-[#FFFFFF]">
            Accessibility
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
